import { createBrowserHistory, Location } from 'history';
import React, { PropsWithChildren, useMemo, useRef } from 'react';
import { Router, useHistory } from 'react-router-dom';
import { UserConfirmation } from '../UnsavedChangesWarning/UserConfirmation';
import { useSelector } from 'react-redux';
import { AppSettingsState } from '@invision/core';

export function useInvHistory() {
  const history = useHistory();

  return {
    goBack: ({ fallbackUrl }: { fallbackUrl?: string }) => {
      // @ts-ignore
      history.goBack({ fallbackUrl });
    }
  };
}

export function InvRouter({
  getHomePath,
  children
}: PropsWithChildren<{
  getHomePath: (location: Location) => string;
}>) {
  const prevLocation = useRef<Location | undefined>(undefined);
  const previousURL = useRef<string>(document.referrer);
  const appLoginUrl = useSelector(AppSettingsState.getLoginUrl);

  const browserHistory = useMemo(() => {
    const defaultHistory = createBrowserHistory({
      basename: WEBPACK_BASENAME,
      getUserConfirmation: UserConfirmation
    });
    defaultHistory.listen((location, action) => {
      if (action === 'PUSH') {
        prevLocation.current = location;
      }
    });

    const originalGoBack = defaultHistory.goBack;

    // @ts-ignore goBack by default does not take any arguments
    defaultHistory.goBack = ({
      fallbackUrl
    }: { fallbackUrl?: string } = {}) => {
      if (
        // if no previous location found
        !prevLocation.current &&
        // if previous page is login page, do not go back to login
        previousURL.current.indexOf(
          `${window.location.origin}${appLoginUrl}`
        ) === -1 &&
        // check if previous url is angular page
        previousURL.current.indexOf(window.location.origin) === 0
      ) {
        window.location.href = previousURL.current;
      } else if (!prevLocation.current) {
        defaultHistory.push(
          fallbackUrl || getHomePath(defaultHistory.location)
        );
      } else {
        originalGoBack();
      }
    };
    return defaultHistory;
  }, []);

  // @ts-ignore
  return <Router history={browserHistory}>{children}</Router>;
}
